import { extendTheme } from '@chakra-ui/react'

import { colors } from '@common/theme/colors'

import * as components from './components'
import * as foundations from './foundations'

export const theme = extendTheme({
  ...foundations,
  components: { ...components },
  colors,
  space: {
    '4.5': '1.125rem',
  },
})

export type Theme = typeof theme
